import { IconDefinition } from '../../types';

const EllipsisV: IconDefinition = {
  name: 'ellipsis-v',
  definition: {
    viewBox: '0 0 64 512',
    pathData:
      'M32 224c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM0 136c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32zm0 240c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32z'
  }
};

export default EllipsisV;
